import PropTypes from 'prop-types';
import React from 'react';
import './QuestionResponseCard.scss';

export default class QuestionResponseCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        title: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
        class: PropTypes.string,
    };

    static defaultProps = {};

    render() {
        return (
            <div
                className={`component-Community-SingleReviewComponent-QuestionResponseCard ${this.props.class}`}
            >
                <div className="card-section-title">{this.props.title}</div>
                <div className="card-main-content-section">
                    {this.props.children}
                </div>
            </div>
        );
    }
}
